// extracted by mini-css-extract-plugin
export default {"wrapper":"headline__wrapper__tlxUZ","container":"headline__container__Xl5vA","title":"headline__title__rZ6eb","description":"headline__description__wW9Ke"};